module.exports = {
	"Search the video": "Cerca il video",
	"Explore": "Esplora",
	"Print": "Stampa",
	"Download": "Scarica",
	"Share": "Condividi",
	"Settings": "Impostazioni",
	"Language": "Lingua",
	"Interface Language": "Lingua dell'interfaccia",
	"Transcript / Captions Language": "Lingua sottotitoli / trascrizione",
	"Transcript Language": "Lingua della trascrizione",
	"Captions Language": "Lingua dei sottotitoli",
	"Show Transcript": "Mostra trascrizione",
	"Show Captions": "Mostra sottotitoli",
	"Show Heatmap": "Mostra la mappa di calore",
	"Show Speakers in Transcript": "Mostra gli interlocutori nella trascrizione",
	"Keyword": "Parola Chiave",
	"Keywords": "Parole Chiave",
	"Topic": "Argomento",
	"Topics": "Argomenti",
	"Speaker": "Interlocutore",
	"Speakers": "Interlocutori",
	"Transcript": "Trascrizione",
	"Previous": "Precedente",
	"Next": "Successivo",
	"Clear": "Svuota",
	"No results found": "Nessun risultato trovato",
	"try another search or explore": "prova con un'altra ricerca o esplora",
	"Share Search": "Condividi ricerche",
	"Share Time": "Condividi al minuto",
	"There is no transcript available in the selected language.": "Nessuna trascrizione disponibile nella lingua selezionata.",
	"Show {{count}} more": "Mostra {{count}} altro",
	"Show {{count}} more_plural": "Mostra altri {{count}}"
};


//////////////////
// WEBPACK FOOTER
// ./locale/it.json
// module id = ./locale/it.json
// module chunks = 0 1